var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _radialGradient, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFootball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 211.2958649088,
    x2: 361.2296077648,
    xlinkHref: "#a",
    y1: 211.2958649088,
    y2: 361.229708157
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 245.777172274,
    x2: 475.3266481634,
    xlinkHref: "#a",
    y1: 3.8558636176,
    y2: 233.405339507
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 113.437162468,
    x2: 218.0285674096,
    xlinkHref: "#a",
    y1: 86.010013428,
    y2: 190.6014183696
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3084656886,
    x2: 125.6034924016,
    xlinkHref: "#a",
    y1: 287.1275147476,
    y2: 358.4225414606
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 370.7105467406,
    x2: 500.9498497616,
    xlinkHref: "#a",
    y1: 242.660998386,
    y2: 372.900301407
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 181.7637926114,
    x2: 311.5653856404,
    xlinkHref: "#a",
    y1: 379.742029837,
    y2: 509.543622866
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 156.7434461742,
    cy: 146.368313873,
    gradientUnits: "userSpaceOnUse",
    r: 393.1106567578
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2795,
    stopColor: "#bedbfc",
    stopOpacity: 0.278431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6141,
    stopColor: "#b2ccf5",
    stopOpacity: 0.611765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9776,
    stopColor: "#9fb4e8",
    stopOpacity: 0.976471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3251"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 236.4057611884,
    x2: 302.1233988382,
    xlinkHref: "#i",
    y1: 247.6377409166,
    y2: 313.3553785664
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 247.7863213726,
    x2: 275.334643798,
    xlinkHref: "#i",
    y1: 0.5101931604,
    y2: 28.058615978
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 490.0831972492,
    x2: 516.1015425466,
    xlinkHref: "#i",
    y1: 189.7681631096,
    y2: 215.786508407
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 9.078466646,
    x2: 26.1197414194,
    xlinkHref: "#i",
    y1: 192.4447195538,
    y2: 209.4860947194
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 106.187841706,
    x2: 143.0409147962,
    xlinkHref: "#i",
    y1: 435.638398953,
    y2: 472.4915724354
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 390.8010338046,
    x2: 404.2945486222,
    xlinkHref: "#i",
    y1: 442.6033086124,
    y2: 456.0969238222
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 512c141.386719 0 256-114.613281 256-256s-114.613281-256-256-256-256 114.613281-256 256 114.613281 256 256 256zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m506.417969 202.632812-108.273438 23.148438c-15.730469 3.363281-32.144531-.519531-44.703125-10.570312l-79.933594-63.96875c-12.710937-10.179688-20.109374-25.582032-20.117187-41.855469v-.101563l.167969-109.2734372c.816406-.0117188 1.628906-.0117188 2.441406-.0117188 123.082031 0 225.882812 86.871094 250.417969 202.632812zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m253.390625 109.285156v.101563c0 16.273437-7.410156 31.675781-20.109375 41.855469l-79.933594 63.96875c-10.902344 8.714843-24.695312 12.800781-38.429687 11.523437-2.097657-.1875-4.195313-.511719-6.285157-.953125l-91.554687-19.574219-11.726563-2.511719c23.964844-115.421874 125.648438-202.378906 247.867188-203.6757808zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m164.792969 384.523438-.683594.773437-61.226563 67.84375c-1.457031 1.617187-3.023437 3.101563-4.667968 4.457031-59.792969-46.863281-98.214844-119.738281-98.214844-201.597656 0-16.714844 1.597656-33.050781 4.65625-48.859375 4.046875-.894531 8.222656-1.214844 12.421875-.933594 2.046875.140625 4.113281.421875 6.164063.863281l89.378906 19.101563c.773437.171875 1.542968.351563 2.296875.5625 14.238281 3.855469 25.632812 14.648437 30.207031 28.785156l28.140625 86.949219c4.710937 14.554688 1.476563 30.5-8.472656 42.054688zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 81.859375-38.421875 154.734375-98.214844 201.597656-1.644531-1.355468-3.210937-2.839844-4.667968-4.457031l-61.226563-67.84375-.683594-.773437c-9.949219-11.554688-13.183593-27.5-8.472656-42.054688l28.140625-86.949219c4.816406-14.890625 17.207031-26.074219 32.503906-29.347656l89.378906-19.101563c6.234376-1.328124 12.558594-1.265624 18.585938.070313 3.058594 15.808594 4.65625 32.144531 4.65625 48.859375zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m411.585938 459.3125c-43.117188 33.050781-97.058594 52.6875-155.585938 52.6875s-112.46875-19.636719-155.585938-52.6875c1.816407-3.3125 4.015626-6.453125 6.582032-9.363281l57.113281-64.652344.683594-.773437.972656-1.09375c9.890625-11.195313 24.117187-17.609376 39.054687-17.609376h102.359376c14.9375 0 29.164062 6.414063 39.054687 17.609376l.972656 1.09375.683594.773437 57.113281 64.652344c2.566406 2.910156 4.765625 6.050781 6.582032 9.363281zm0 0",
    fill: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m256 512c141.386719 0 256-114.613281 256-256s-114.613281-256-256-256-256 114.613281-256 256 114.613281 256 256 256zm0 0",
    fill: "url(#h)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m227.898438 155.3125-65.199219 47.371094c-16.757813 12.171875-23.769531 33.753906-17.367188 53.453125l24.902344 76.644531c6.402344 19.699219 24.757813 33.035156 45.472656 33.035156h80.585938c20.714843 0 39.070312-13.335937 45.472656-33.035156l24.902344-76.644531c6.402343-19.699219-.609375-41.28125-17.367188-53.453125l-65.199219-47.371094c-16.757812-12.171875-39.445312-12.171875-56.203124 0zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m322.519531 8.722656-38.417969 27.910156c-16.757812 12.179688-39.445312 12.179688-56.203124 0l-38.417969-27.910156c21.210937-5.691406 43.507812-8.722656 66.519531-8.722656s45.308594 3.03125 66.519531 8.722656zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m511.820312 246.371094-17.226562-12.003906c-17-11.839844-24.4375-33.28125-18.421875-53.097657l10.832031-35.730469c14.714844 30.71875 23.488282 64.824219 24.816406 100.832032zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m17.40625 234.367188-17.226562 12.003906c1.328124-36.007813 10.101562-70.113282 24.816406-100.832032l10.832031 35.730469c6.015625 19.816407-1.421875 41.257813-18.421875 53.097657zm0 0",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m159.574219 493.214844c-40.179688-16.34375-75.265625-42.605469-102.230469-75.742188l49.234375 2.980469c20.679687 1.253906 38.199219 15.671875 43.386719 35.71875zm0 0",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m454.65625 417.472656c-26.964844 33.136719-62.050781 59.398438-102.230469 75.742188l9.609375-37.042969c5.1875-20.046875 22.707032-34.464844 43.386719-35.71875zm0 0",
    fill: "url(#o)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFootball);
export default __webpack_public_path__ + "static/media/icon-football.6eb9462a61b61e6ea7f49ebd8caa8c90.svg";
export { ForwardRef as ReactComponent };